var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTranslateOn = function SvgTranslateOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53721 15H17.4705C19.4838 14.994 21.4068 14.2004 22.7919 12.8038C24.2167 11.3748 25.0075 9.47403 24.9984 7.5C25.0846 3.4425 21.7152 0.0855798 17.4705 0H7.53721C3.28982 0.0823706 -0.0837604 3.44 0.00158422 7.5C-0.0829007 11.5597 3.29019 14.9168 7.53721 15Z",
    fill: "#48A9A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7.50516C23.0021 5.28019 21.6633 3.27316 19.6083 2.42028C17.5533 1.56739 15.1869 2.03669 13.6128 3.60925C12.0388 5.18182 11.5673 7.54783 12.4183 9.60363C13.2693 11.6594 15.2751 13 17.5001 13C20.536 13.0009 22.9981 10.5411 23 7.50516Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTranslateOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/translate-on.b3137ec09b8e257259b0f3897d11281b.blank.svg";